module.exports = __webpack_public_path__ + "static/media/news4.08c38b03.jpeg";